"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationBadge = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var NotificationBadge = function NotificationBadge(props) {
  var _a, _b, _c;
  var _d, _e;
  var notificationBadgeClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('notification-badge-content')] = true, _a['disabled'] = props.disabled, _a);
  var notificationBadgeContainerClasses = (_b = {}, _b[vdl_prefix_1.vdlPrefix("notification-badge-" + ((_d = props.badgeContent) === null || _d === void 0 ? void 0 : _d.type) + "-container")] = true, _b[vdl_prefix_1.vdlPrefix("notification-badge--" + props.size)] = !!props.size, _b[vdl_prefix_1.vdlPrefix("notification-badge-status--" + (props === null || props === void 0 ? void 0 : props.status))] = !!props.status, _b[vdl_prefix_1.vdlPrefix('notification-badge-filled')] = props.badgeFilled, _b);
  var notificationBadgeTextClasses = (_c = {}, _c[vdl_prefix_1.vdlPrefix("notification-badge-" + ((_e = props.badgeContent) === null || _e === void 0 ? void 0 : _e.type) + "-content")] = true, _c);
  return react_1.default.createElement("div", {
    className: classnames_1.classNames(props.className, notificationBadgeClasses),
    title: props.title
  }, react_1.default.createElement("div", {
    className: classnames_1.classNames(notificationBadgeContainerClasses)
  }, props.badgeContent && react_1.default.createElement("div", {
    className: classnames_1.classNames(notificationBadgeTextClasses)
  }, react_1.default.createElement("span", {
    className: "truncate-text"
  }, props.badgeContent.value))));
};
exports.NotificationBadge = NotificationBadge;
exports.NotificationBadge.propTypes = {
  badgeContent: prop_types_1.default.object,
  color: prop_types_1.default.string,
  disabled: prop_types_1.default.bool,
  badgeFilled: prop_types_1.default.bool,
  size: prop_types_1.default.oneOf(['xs', 'sm']),
  status: prop_types_1.default.oneOf(['success', 'info', 'error', 'warning', 'attention', 'pending', 'start', 'tip', 'neutral', 'default']),
  title: prop_types_1.default.string
};
exports.NotificationBadge.defaultProps = {
  disabled: false,
  badgeFilled: true,
  size: 'sm'
};
exports.NotificationBadge.displayName = 'NotificationBadge';